import { Component, Input } from '@angular/core';

@Component({
  selector: 'sales-cover-starting-date',
  templateUrl: './cover-starting-date.component.html',
  styleUrls: ['./cover-starting-date.component.scss'],
})
export class CoverStartingDateComponent {
  @Input() isHeating: boolean | null = false;
  @Input() whiteGoodsCoverInformation =
    'If your appliance is in guarantee, cover will start once we have processed your application. If your appliance is out of guarantee, cover will start after a 30 day wait.';
  @Input() panel = true;
  @Input() showPDContent: boolean | null = false;
  @Input() hasMultiQuotes: boolean | null = false;
}
